module.exports = __webpack_public_path__ + "static/NightInTheWoods2-f5ae68601023d0bd46e37641b483456d.webp";